import { ERouterList } from '@internal/router/constants/router-list'
import { EUserRole } from '@shared/api/user-management/resources/user/constants/user-roles'

import InnerLayout from '@internal/layouts/inner-layout.vue'

import { auth } from '@internal/router/middleware/auth'
import { permissions } from '@internal/router/middleware/permissions'

export const organizations = [
  {
    path: '/organizations',
    name: ERouterList.ORGANIZATIONS,
    component: () => import('@internal/pages/organizations/index.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/organizations/create',
    name: ERouterList.ORGANIZATIONS_CREATE,
    component: () => import('@internal/pages/organizations/create.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/organizations/:id',
    name: ERouterList.ORGANIZATION,
    component: () => import('@internal/pages/organizations/_id/index.vue'),
    meta: {
      middleware: [auth, permissions],
      layout: InnerLayout,
    },
  },
  {
    path: '/organizations/:id/admins/create',
    name: ERouterList.ORGANIZATION_ADMIN_CREATE,
    component: () => import('@internal/pages/organizations/_id/admins/create.vue'),
    meta: {
      middleware: [auth, permissions],
      layout: InnerLayout,
      middlewareRoleList: [EUserRole.PRACTICE_ADMIN, EUserRole.ORGANIZATION_ADMIN],
    },
  },
  {
    path: '/organizations/:id/admins/:userId',
    name: ERouterList.ORGANIZATION_ADMIN,
    component: () => import('@internal/pages/organizations/_id/admins/_userId/index.vue'),
    meta: {
      middleware: [auth, permissions],
      layout: InnerLayout,
      middlewareRoleList: [EUserRole.PRACTICE_ADMIN, EUserRole.ORGANIZATION_ADMIN],
    },
  },
  {
    path: '/organizations/:id/admins/:userId/edit',
    name: ERouterList.ORGANIZATION_ADMIN_EDIT,
    component: () => import('@internal/pages/organizations/_id/admins/_userId/edit.vue'),
    meta: {
      middleware: [auth, permissions],
      layout: InnerLayout,
      middlewareRoleList: [EUserRole.PRACTICE_ADMIN, EUserRole.ORGANIZATION_ADMIN],
    },
  },
  {
    path: '/organizations/:id/communities/create',
    redirect: {
      name: ERouterList.LOCATION_CREATE,
    },
  },
  {
    path: '/organizations/:id/locations/create',
    name: ERouterList.LOCATION_CREATE,
    component: () => import('@internal/pages/organizations/_id/locations/create.vue'),
    meta: {
      middleware: [auth, permissions],
      layout: InnerLayout,
      middlewareRoleList: [EUserRole.PRACTICE_ADMIN],
    },
  },
  {
    path: '/organizations/:id/communities/:locationId',
    redirect: {
      name: ERouterList.LOCATION,
    },
  },
  {
    path: '/organizations/:id/locations/:locationId',
    name: ERouterList.LOCATION,
    component: () => import('@internal/pages/organizations/_id/locations/_locationId/index.vue'),
    meta: {
      middleware: [auth, permissions],
      layout: InnerLayout,
    },
  },

  {
    path: '/organizations/:id/communities/:locationId/qr-code',
    redirect: {
      name: ERouterList.LOCATION_QR_CODE,
    },
  },

  {
    path: '/organizations/:id/locations/:locationId/qr-code',
    name: ERouterList.LOCATION_QR_CODE,
    component: () => import('@internal/pages/organizations/_id/locations/_locationId/qr-code.vue'),
    meta: {
      middleware: [auth, permissions],
      layout: InnerLayout,
    },
  },
  {
    path: '/organizations/:id/communities/:locationId/existing-user',
    redirect: {
      name: ERouterList.LOCATION_QR_CODE,
    },
  },
  {
    path: '/organizations/:id/locations/:locationId/existing-user',
    name: ERouterList.LOCATION_EXISTING_USER,
    component: () => import('@internal/pages/organizations/_id/locations/_locationId/existing-user.vue'),
    meta: {
      middleware: [auth, permissions],
      layout: InnerLayout,
    },
  },
  {
    path: '/organizations/:id/communities/:locationId/edit',
    redirect: {
      name: ERouterList.LOCATION_EDIT,
    },
  },
  {
    path: '/organizations/:id/locations/:locationId/edit',
    name: ERouterList.LOCATION_EDIT,
    component: () => import('@internal/pages/organizations/_id/locations/_locationId/edit.vue'),
    meta: {
      middleware: [auth, permissions],
      layout: InnerLayout,
    },
  },
  {
    path: '/organizations/:id/communities/:locationId/users/create',
    redirect: {
      name: ERouterList.LOCATION_USER_CREATE,
    },
  },
  {
    path: '/organizations/:id/locations/:locationId/users/create',
    name: ERouterList.LOCATION_USER_CREATE,
    component: () => import('@internal/pages/organizations/_id/locations/_locationId/users/create.vue'),
    meta: {
      middleware: [auth, permissions],
      layout: InnerLayout,
    },
  },
  {
    path: '/organizations/:id/communities/:locationId/users/:userId',
    redirect: {
      name: ERouterList.LOCATION_USER,
    },
  },
  {
    path: '/organizations/:id/locations/:locationId/users/:userId',
    name: ERouterList.LOCATION_USER,
    component: () => import('@internal/pages/organizations/_id/locations/_locationId/users/_userId/index.vue'),
    meta: {
      middleware: [auth, permissions],
      layout: InnerLayout,
    },
  },
  {
    path: '/organizations/:id/communities/:locationId/users/:userId/edit',
    redirect: {
      name: ERouterList.LOCATION_USER_EDIT,
    },
  },
  {
    path: '/organizations/:id/locations/:locationId/users/:userId/edit',
    name: ERouterList.LOCATION_USER_EDIT,
    component: () => import('@internal/pages/organizations/_id/locations/_locationId/users/_userId/edit.vue'),
    meta: {
      middleware: [auth, permissions],
      layout: InnerLayout,
    },
  },
]

export default organizations
